<template>
  <div class="news-list-page">
    <section class="banner-section">
      <img src="@/assets/pic/news-ban.jpg" alt="新聞資訊" class="banner-img" />
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1 class="banner-title">{{ $i18n.t("news.bannerTitle") }}</h1>
        <p class="banner-subtitle">{{ $i18n.t("news.bannerDesc") }}</p>
      </div>
    </section>

    <section class="main-section">
      <div class="container">
        <div class="category-tabs">
          <span class="tab-item active">{{ $i18n.t("news.tabCompany") }}</span>
        </div>

        <div class="news-cards-grid">
          <div
            class="news-card scroll-animate fade-up"
            v-for="(news, index) in newsList"
            :key="news.id"
            :data-delay="(index + 1) * 100"
            @click="goToDetail(news.id)"
          >
            <div class="card-header">
              <span class="cat-tag">{{ news.category }}</span>
              <div class="date-box">
                <span class="year-month">{{ news.year_month }}</span>
                <span class="day-num">{{ news.day }}</span>
              </div>
            </div>
            
            <h3 class="news-title">{{ news.title }}</h3>
            <p class="news-desc">{{ news.desc }}</p>
            
            <div class="arrow-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useScrollAnimation } from "../composables/useScrollAnimation";
import localNewsData from "@/mock/news.json";

useScrollAnimation();
const router = useRouter();
const newsList = ref([]);

onMounted(() => {
  newsList.value = localNewsData;
});

const goToDetail = (id) => {
  router.push(`/news/${id}`);
};
</script>

<style scoped>
.news-list-page {
  min-height: 100vh;
}

/* ====== 🎯 完美复制你原版的 Banner 样式，高度尺寸完全没变 ====== */
.banner-section {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(0, 20, 40) 0%,
    rgba(0, 20, 40, 0.78) 60%,
    transparent 100%
  );
  pointer-events: none;
  z-index: 1;
}

.banner-img {
  width: 100%;
  object-fit: cover;
  display: block;
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 12rem;
  transform: translateY(-50%);
  z-index: 2;
}

.banner-title {
  font-size: 3rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 0.75rem;
  letter-spacing: 0.125rem;
}

.banner-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  max-width: 31.25rem;
}

/* ====== 列表页核心布局 ====== */
.container {
  max-width: 87rem;
  margin: 0 auto;
  padding: 0 1.25rem;
}

.main-section {
  padding: 5rem 0;
  background-color: #fff;
}

/* 分类Tab导航栏 */
.category-tabs {
  display: flex;
  gap: 2.5rem;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 3rem;
  padding-bottom: 0.75rem;
}

.tab-item {
  font-size: 1.1rem;
  color: #666;
  cursor: pointer;
  position: relative;
  padding-bottom: 0.75rem;
  transition: color 0.3s;
}

.tab-item.active, .tab-item:hover {
  color: #1a3a5c;
  font-weight: bold;
}

.tab-item.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #8b1e21; /* 暗红色活动下划线 */
}

/* 新闻卡片三列布局（图1样式） */
.news-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.news-card {
  background: #fff;
  border-radius: 4px;
  padding: 2.5rem 2rem;
  position: relative;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03);
  transition: transform 0.3s, box-shadow 0.3s;
  display: flex;
  flex-direction: column;
}

.news-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(27, 68, 149, 0.08);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.cat-tag {
  border: 1px solid #1a3a5c;
  color: #1a3a5c;
  padding: 0.2rem 0.6rem;
  font-size: 0.85rem;
  border-radius: 4px;
}

.date-box {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.year-month {
  font-size: 0.9rem;
  color: #aaa;
}

.day-num {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
  line-height: 1;
  margin-top: 0.2rem;
}

.news-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 1.5rem;
  line-height: 1.4;
}

.news-desc {
  font-size: 1.05rem;
  color: #666;
  line-height: 1.8;
  text-align: justify;
  margin-bottom: 2rem;
  flex: 1;
}

/* 圆圈小外框加箭头 */
.arrow-btn {
  width: 2.2rem;
  height: 2.2rem;
  background-color: #16355c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.news-card:hover .arrow-btn {
  background-color: #8b1e21;
}

/* ====== 响应式高度完全照搬原版 ====== */
@media (max-width: 48rem) {
  .banner-section {
    height: 17.5rem;
  }
  .banner-content {
    left: 1.875rem;
  }
  .banner-title {
    font-size: 1.5rem;
  }
  .banner-subtitle {
    font-size: 1rem;
  }
  .news-cards-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  .main-section {
    padding: 3.125rem 0;
  }
}

@media (max-width: 30rem) {
  .banner-title {
    font-size: 1.5rem;
  }
}
</style>